<template>
    <div class="news-list-content">
        <h2 class="module-name">{{articleData.title}}</h2>
        <ul class="news-list">
            <li class="news-item" v-for="(item, index) in articleData.list" :key="index">
                <span class="title-point"></span>
                <a class="title" :href="item.url" :data-spm-data="`${templateSpm}-${index+1}`">
                    <i class="icon-picture" v-if="item.type==3"></i>{{item.title}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArtListNews',
}
</script>

<style lang="less" scoped>
    @import '../../less/base/mixins.less';
    .news-list-content {
        box-sizing: border-box;
        padding: 40px 0 20px 28px;
        border-radius: 6px;
        background: #F0F0F0;
        .module-name {
            margin-bottom: 12px;
            padding-left: 28px;
            font-size: 32px;/*px*/
            font-weight: bold;
            color: #656565;
        }
        .news-item {
            position: relative;
            border-bottom: 1px solid #E0E0DE;/*no*/
            margin-right: 32px;
            overflow: hidden;
            color: #656565;
            &:last-child {
                border-bottom: 0;
            }
            .title-point {
                position: absolute;
                top: 30px;
                left: 0;
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 24px;
                background-color: #D7D7D7; 
            }
            .title {
                display: inline-block;
                line-height: 38px;/*px*/
                font-size: 32px;/*px*/
                max-height: 76px;/*px*/
                margin: 20px 0 20px 28px;
                overflow: hidden;
                .line-clamp(2);
                .icon-picture {
                    display: inline-block;
                    height: 38px;/*px*/
                    margin-right: 8px;
                    line-height: 32px;/*px*/
                    vertical-align: middle; 
                    font-size: 28px;/*px*/
                    color: #6D98D4;
                }
            }
        }
    }
</style>